import React from 'react';

export default function SuggestionCard({ data, onRespond }) {
  return (
    <>
      {data.title && <div className="ws-card__title">{data.title}</div>}

      <div className="ws-card-suggestion">
        {data.suggestion && (
          <div className="ws-card-suggestion__text">{data.suggestion}</div>
        )}
        {data.reasoning && (
          <div className="ws-card-suggestion__reasoning">{data.reasoning}</div>
        )}
      </div>

      {!data.answered && (
        <div className="ws-card-actions">
          <button
            className="ws-card-btn ws-card-btn--primary"
            onClick={() => onRespond(data.id, 'accept')}
            type="button"
          >
            Accepteer
          </button>
          <button
            className="ws-card-btn"
            onClick={() => onRespond(data.id, 'modify')}
            type="button"
          >
            Aanpassen
          </button>
          <button
            className="ws-card-btn"
            onClick={() => onRespond(data.id, 'skip')}
            type="button"
          >
            Overslaan
          </button>
        </div>
      )}
    </>
  );
}
